import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { Card, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import useStyles from './styles';
import { getAllApps, getAddApp, getRemoveApp } from '../../redux/Actions/applications.action';
import Notifications from '../notifications/Notifications';
import InstanceName from '../../components/InstanceName';
import { getClient } from '../../redux/Actions/clientInfo.action';

export default function App() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const clientInfo = useSelector((state) => state.clientReducer.clientInfo);
    const allApps = useSelector((state) => state.applicationsReducer.allApps);

    const [installedApps, setInstalledApps] = useState([]);
    const [APP, setAPP] = useState([]);

    const borderColor = (value) => {
        if (value) {
            return {
                border: '2px solid #ABF5D2'
            };
        }
        return {};
    };
    const addApp = async (id) => {
        const tenantId = Cookies.get('tenantId') || clientInfo.tenantId;
        const para = {
            appId: id,
            tenantId
        };
        if (tenantId) {
            try {
                await dispatch(getAddApp(para));
                toast.success('App installed successfully');
                setInstalledApps([...installedApps, id]);
            } catch (error) {
                toast.error('Error while adding app');
            }
        } else {
            toast.error('Error while adding app');
        }
    };
    const removeApp = async (id) => {
        const tenantId = Cookies.get('tenantId') || clientInfo.tenantId;
        const para = {
            appId: id,
            tenantId
        };
        if (tenantId) {
            try {
                await dispatch(getRemoveApp(para));
                const removeArr = installedApps.filter((iA) => iA !== id);
                toast.success('App uninstalled successfully');
                setInstalledApps(removeArr);
            } catch (error) {
                toast.error('Error while deleting app');
            }
        } else {
            toast.error('Error while deleting app');
        }
    };

    useEffect(() => {
        dispatch(getAllApps());
        const tenantId = Cookies.get('tenantId') || clientInfo.tenantId;
        dispatch(getClient(tenantId));
    }, [dispatch, clientInfo.tenantId]);

    useEffect(() => {
        if (clientInfo.installedApps) {
            setInstalledApps(clientInfo.installedApps);
        }
    }, [clientInfo]);

    useEffect(() => {
        if (allApps.length) {
            allApps.map((e) => {
                if (installedApps.includes(e._id)) {
                    e.isInstalled = true;
                } else e.isInstalled = false;
                return e;
            });
            setAPP([...allApps]);
        }
    }, [allApps, installedApps]);

    return (
        <>
            <Notifications />
            <div className={classes.nameResponsive}>
                <InstanceName />
            </div>
            <div className={classes.cardsOutline}>
                <Grid container>
                    {APP.map((apl, idx) => (
                        <>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={4}
                                xl={3}
                                style={{ padding: '0px 15px 25px' }}
                            >
                                <Card
                                    key={idx}
                                    variant="outlined"
                                    sx={borderColor(apl.isInstalled)}
                                    className={classes.cardContainer}
                                >
                                    <div className={classes.fixIcon}>
                                        <Typography variant="h3" className={classes.cardHead}>
                                            {apl.name}
                                        </Typography>
                                        <Typography
                                            variant="subtitle1"
                                            className={classes.cardText}
                                        >
                                            {apl.description}
                                        </Typography>
                                    </div>
                                    <div className={classes.alignIcon}>
                                        {apl.isInstalled === true ? (
                                            <button
                                                className={classes.buttonIconCheck}
                                                onClick={() => removeApp(apl._id)}
                                            >
                                                <CheckIcon className={classes.iconCheck} />
                                            </button>
                                        ) : (
                                            <button
                                                className={classes.buttonIconAdd}
                                                onClick={() => addApp(apl._id)}
                                            >
                                                <AddIcon />
                                            </button>
                                        )}
                                    </div>
                                </Card>
                            </Grid>
                        </>
                    ))}
                </Grid>
            </div>
        </>
    );
}
